
globalThis.CkeditorInlineModule = (function() {
  function CkeditorInlineModule($html) {
    this.$html = $html;
  }

  CkeditorInlineModule.init = function($html) {
    var $html = $html || $('body');

    $html.find('.textarea-ckeditor-inline').each(function() {
        new CkeditorInlineModule($(this)).init();
    });
  }

  CkeditorInlineModule.prototype = {
    init: function() {
      var toolbar = {
        'mini': [
          {
            name: 'basicstyles',
            groups: ['basicstyles', 'cleanup'],
            items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat']
          },
          {
            name: 'paragraph',
            groups: ['list', 'align'],
            items: ['NumberedList', 'BulletedList']
          },
          {
            name: 'links',
            items: ['Link', 'Unlink']
          },
        ]
      }

      var $textContainer = this.$html;
      var $textarea = $textContainer.closest('.form-group').find('textarea');
      utils.require([assets.ckeditor], function() {
        var targetId = $textContainer.attr('id'),
          editorParams = {
            enterMode : CKEDITOR.ENTER_BR,
            skin: 'moono-lisa',
            removePlugins: 'font',
            extraPlugins: '',
          };

        if($textContainer.data('allowed-content') != undefined) {
          editorParams["allowedContent"] = $textContainer.data('allowed-content')
        }

        if ($textContainer.data('toolbar') != undefined) {
          editorParams["toolbar"] = toolbar[$textContainer.data('toolbar')]
        }

        var editor = CKEDITOR.inline(targetId, editorParams);

        editor.on('paste', function (e) {
          e.stop();
          var data = e.data.dataValue;
          e.editor.insertHtml(data);
        });

        editor.on('change', function(){
          var ckeditor = this;
          var textareaValue = ckeditor.getData();
          $textarea.val(textareaValue);
          $textarea.trigger('change');
        });
      });
    }
  }

  return CkeditorInlineModule;
})();
